// extracted by mini-css-extract-plugin
export var closeButton = "_3j-3";
export var header = "_3j-0";
export var link = "_3j-1";
export var retryButton = "_3j-2";